<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col align="center" cols="12" sm="8">
        <div v-for="course in courses" :key="course.id">
          <div>{{course.code}} - {{course.title}}</div>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ID</th>
                  <th class="text-left">Name</th>
                  <!-- <th class="text-left">Start time</th> -->
                  <th class="text-left">Duration (minutes)</th>
                  <th class="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="exam in course.exams" :key="exam.id">
                  <td>{{ exam.id }}</td>
                  <td>
                    <!-- <a href="/next">{{ exam.name }}</a> -->
                    <router-link :to="'/exam/' + exam.id">{{ exam.name }}</router-link>
                  </td>
                  <!-- <td>{{ new Date(exam.startTime).toLocateDateString() }}</td> -->
                  <td>{{ exam.duration }}</td>
                  <td>{{ exam.status }}</td>
                  <td>
                    <!-- <a href="/next">{{ exam.name }}</a> -->
                    <router-link :to="'/showStudents/' + exam.id">See students</router-link>
                  </td>
                </tr>
              </tbody>
              <!-- <tfoot>
            <td colspan="2">
              
            </td>
              </tfoot>-->
            </template>
          </v-simple-table>
          <!-- <v-btn color="primary" to="/new">New Exam</v-btn> -->
          <v-row>
            <v-col cols="12" sm="4">
              <!-- <v-text-field label="New exam element" single-line v-model="newExamName"></v-text-field> -->
              <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      dark
                      v-on="on"
                      @click="showDialog(course.id)"
                    >New Assessment</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">New Assessment</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="8">
                            <v-text-field
                              label="Assessment Name*"
                              v-model="new_course.name"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="4">
                            <v-text-field
                              label="Duration*"
                              hint="in hours"
                              persistent-hint
                              type="number"
                              v-model="new_course.duration"
                              required
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <!-- <v-text-field label="Email*" required></v-text-field> -->
                            <v-datetime-picker
                              label="Select Datetime*"
                              v-model="new_course.datetime"
                              required
                            ></v-datetime-picker>
                          </v-col>
                        </v-row>
                      </v-container>
                      <small>*indicates required field</small>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-btn
                        color="blue darken-1"
                        text
                        @click="dialog = false; new_course = {};"
                      >Close</v-btn>
                      <v-btn color="blue darken-1" text @click="newAssessment()">Create</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </v-col>
          </v-row>

          <br />
          <br />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
export default {
  name: "InCourses",

  methods: {
    showDialog(cid) {
      this.dialog = true;
      this.current_cid = cid;
    },

    async newAssessment() {
      // if (!this.newExamName) return alert("can't leave it blank");

      // alert(this.current_cid);

      var response = await fetch(
        process.env.VUE_APP_API_BASE_URL + "/exam/create/" + this.current_cid,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: JSON.stringify(this.new_course)
        }
      );

      if (response.ok) {
        var data = await response.text();
        // console.log(data);
        // alert(JSON.stringify(data));
        // this.courses = data;
        this.dialog = false;
        this.$router.push({ path: `/exam/${data}` }); // -> /user/123
      } else {
        alert(response.status + ": " + response.statusText);
      }
    }
  },

  data() {
    return {
      courses: [],
      // newExamName: "",
      dialog: false,
      // datetime: "",
      new_course: { name: "", duration: 0, datetime: "" },
      current_cid: ""
    };
  },

  async mounted() {
    var response = await fetch(
      process.env.VUE_APP_API_BASE_URL + "/instructor/view/",
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
          // 'Content-Type': 'application/x-www-form-urlencoded',
        }
      }
    );

    if (response.ok) {
      var data = await response.json();
      console.log(data);
      // alert(JSON.stringify(data));
      this.courses = data;
    } else {
      alert(response.status + ": " + response.statusText);
    }
  }
};
</script>